// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__V5-G+","primary":"CustomButton_primary__ZDr5g","secondary":"CustomButton_secondary__DiXZj","disabledBtn":"CustomButton_disabledBtn__Ygtsp"};